if ( module.hot ) {
  module.hot.accept();
}

/**
 * Contact form behaviour (G25-1085).
 *
 * Was ~14.4 KB of unminified inline JS emitted by
 * views/contact/includes/contactForm.cfm on every page that renders the form —
 * twice on a contact page, since the page form and the modal form each included
 * it. Inline script is never cached, so those bytes were re-downloaded and
 * re-parsed on every navigation.
 *
 * The view now emits a <script type="application/json" class="gpw-contact-form-config">
 * island per form carrying only the per-form values (formPrefix, current
 * location), plus window.gpwContactForm once per request for the values that are
 * the same for every form on the page. Everything below ships in
 * gpw-public.min.js instead.
 *
 * The old contactFormScriptLoaded_<prefix> guard is gone: each config island is
 * read exactly once here, so there is nothing to double-execute.
 *
 * Per-form state (isSubmitting, the timeout handle) lives in the initContactForm
 * closure, which is what the original IIFE-per-include gave us. reCAPTCHA's
 * data-callback and podium's inline onclick both resolve function names off
 * window, so those two are still published as prefix-scoped globals.
 */

function initContactForm(config, shared) {
	var formPrefix = config.formPrefix || '';

	// Sanitized suffix used to expose closure-scoped functions as GLOBALS for
	// reCAPTCHA data-callback / podium onclick. Matches the CFML callbackSuffix:
	// '' for the page form, 'modal' for the modal form.
	var scopedSuffix = formPrefix.replace(/[^0-9A-Za-z]/g, '');

	var locationVendors = shared.locationVendors || [];
	var bookingLink = shared.bookingLink || '';
	var doctors = shared.doctors || [];
	var useSpamControl = !!shared.useSpamControl;

	if (shared.podiumLocation) {
		var podiumSend = function() {
			var name = document.getElementById(formPrefix + 'fullname').value;
			var phone = document.getElementById(formPrefix + 'phone').value;
			var body = document.getElementById(formPrefix + 'message').value;
			PodiumWebChat.send({
				locationUid: shared.podiumLocation,
				customerName: name,
				customerPhoneNumber: phone,
				body: body
			}).then(console.log('sent'));
		};
		// Expose as a global so the inline onclick="podiumSend<suffix>()" can reach it.
		window['podiumSend' + scopedSuffix] = podiumSend;
	}

	// Flag to prevent duplicate submissions - must be in outer scope
	var isSubmitting = false;
	var submissionTimeoutId = null;

	function startSubmissionTimeout() {
		if (submissionTimeoutId) {
			clearTimeout(submissionTimeoutId);
		}
		submissionTimeoutId = setTimeout(function() {
			var $errors = $('#' + formPrefix + 'contact-form-errors');
			$errors.empty();
			$errors.css('display', 'block');
			$errors.removeClass('all-fixed');
			$errors.append('Your submission is taking longer than expected. Please check your internet connection and try again, or call us directly.');
			$('.contact-pod').css('height', 'auto');

			// Reset submission state so user can try again
			isSubmitting = false;
			$('#' + formPrefix + 'contactform').data('submitting', false);
			$('#' + formPrefix + 'submitter').prop('disabled', false).removeClass('disabled').show();
			$('#' + formPrefix + 'submitterDisabled').hide();

			// Reset reCAPTCHA if present
			if (typeof grecaptcha !== 'undefined') {
				grecaptcha.reset();
			}
		}, 20000);
	}

	// QA TEST: when phone is 555-555-5555, do not submit (startSubmissionTimeout will show message after 20s)
	function doSubmitForm(form) {
		if (!form) return;
		var phoneInput = form.querySelector('input[name="phone"]');
		if (phoneInput && phoneInput.value === '555-555-5555') {
			return;
		}
		if (typeof form.submit === 'function') {
			form.submit();
		}
	}

	function checkReCAPTCHAResponse(token) {
		// Prevent duplicate submissions
		if(isSubmitting || $('#' + formPrefix + 'contactform').data('submitting') === true) {
			return false;
		}

		// Set flags IMMEDIATELY to prevent any other submissions
		isSubmitting = true;
		$('#' + formPrefix + 'contactform').data('submitting', true);

		$('#g-recaptcha-response').val(token);
		// Disable submit button after validation passes
		$('#' + formPrefix + 'submitter').prop('disabled', true).addClass('disabled');
		if($('#' + formPrefix + 'submitterDisabled').length) {
			$('#' + formPrefix + 'submitter').hide();
			$('#' + formPrefix + 'submitterDisabled').show();
		}

		// Start timeout safeguard before submitting
		startSubmissionTimeout();

		// Submit the form (doSubmitForm handles QA test and native submit)
		doSubmitForm(document.getElementById(formPrefix + 'contactform'));
	}
	// reCAPTCHA resolves data-callback as a GLOBAL function by name, so publish a
	// prefix-scoped global. Name matches the button's data-callback="checkReCAPTCHAResponse<suffix>".
	window['checkReCAPTCHAResponse' + scopedSuffix] = checkReCAPTCHAResponse;

	function referralSelect() {
		var referral = $('#' + formPrefix + 'howHeardAbout').val().toLowerCase();
		if ($.inArray(referral, ["word of mouth", "other", "friend"]) >= 0) {
			$('#' + formPrefix + 'referral').show();
		} else {
			$('#' + formPrefix + 'referral').hide();
		}
	}

	function doctorSelect() {
		$('select[name="doctorPreference"]').empty();
		var options = '<option value="No Preference">No Preference</option>';
		doctors.forEach( function(doc) {
			if(doc.location === locationChoiceID) {
				options += '<option value="' + doc.doctor + '">' + doc.doctor + '</option>';
			}
		});
		$('select[name="doctorPreference"]').html(options);
	}

	// The CFML branched on rc.siteInfo.locations.len() to pick the selector, so
	// that count is passed through rather than inferred: a single-location page
	// still has two input[name=locationID] elements (page form + modal), and a
	// multi-location page hides some, so the DOM count means neither thing.
	// [checked] is the HTML attribute, not the :checked property — that is the
	// original behaviour, and it only differs after a click, by which point this
	// has already run.
	var locationChoiceID = shared.locationCount > 1
		? $('input[name=locationID][checked]').val()
		: $('input[name=locationID]').val();

	doctorSelect();

	function toggleDisabledSubmitter(disable) {
		if (disable) {
			$('#' + formPrefix + 'submitter').hide();
			$('#' + formPrefix + 'submitterDisabled').show();
		} else {
			$('#' + formPrefix + 'submitterDisabled').hide();
			$('#' + formPrefix + 'submitter').show();
		}
	}

	$(document).ready(function($) {

		function toggleLocationForm(location, id) {
			var $iframe = $('#' + formPrefix + 'customForm');
			var $customForm = $('#' + formPrefix + 'customFormWrap');
			var $contactForm = $('#' + formPrefix + 'contactform');
			var locationFound = false;
			if (location.locationID == id && location.customForm.length) {
				$iframe.attr('src', location.customForm);
				$customForm.css({ 'display': 'block' });
				$contactForm.css({ 'display': 'none' });
			} else {
				$customForm.css({ 'display': 'none' });
				$contactForm.css({ 'display': 'block' });
			}
			for(let vendor of locationVendors) {
				if(vendor.locationID == id && vendor.uri.length && vendor.uri != '/contact') {
					$('a.gpw-booking.appt-btn').prop('href',vendor.uri);
					$('a.gpw-booking.appt-btn').prop('target','_blank');
					$('.gpw-3rd-Party').css({ 'display':'block' });
					locationFound = true;
				}
				if(!locationFound) {
					if(bookingLink.length && bookingLink != '/contact') {
						$('a.gpw-booking.appt-btn').prop('href',bookingLink);
						$('.gpw-3rd-Party').css({ 'display':'block' }) ;
					} else {
						$('a.gpw-booking.appt-btn').prop('href','#');
						$('.gpw-3rd-Party').css({ 'display':'none' }) ;
					}
				}
			}
		}

		var locationInputs = $('input[name=locationID]');
		var $checkedLocationEl = $('input[name=locationID]:checked');
		var locations = window.gpwLocations;
		var currentLocation = config.currentLocationID;
		var checkedLocation = locations.filter(obj => {
			return obj.locationID == $checkedLocationEl.val();
		});
		if (locations.length > 1) {
			if (currentLocation !== 0) {
				var location = locations.filter(obj => {
					return obj.locationID == currentLocation;
				});
				toggleLocationForm(location[0], currentLocation);
			} else {
				toggleLocationForm(checkedLocation[0], checkedLocation[0].locationID);
				$('.contact-form #' + formPrefix + 'locationID').val(checkedLocation[0].locationID);

				$.each(locationInputs, function(i, val) {
					$(locationInputs[i]).click(function() {
						locationID = $(val).val();
						$('.contact-form #' + formPrefix + 'locationID').val(locationID);
						toggleLocationForm(locations[i], locationID);
					});
				});
			}
		} else {
			toggleLocationForm(locations[0], locations[0].locationID);
		}

		$('input[name=contacttype]').on('click',function(e) {
			if (e.currentTarget.value == 'appt') {
				$('#' + formPrefix + 'appointment').css('display','');
				$('.gpw-3rd-Party').css('display','');
			} else {
				$('#' + formPrefix + 'appointment').css('display','none');
				$('.gpw-3rd-Party').css('display','none');
			}
		});

		$('input[name=locationID]').on('click',function(e){
			locationChoiceID = $(this).val();
			for(let location of locations) {
				// Was `location.locationID = locationChoiceID` (assignment) inline.
				// Since G25-1082 this array is window.gpwLocations, shared with
				// js-google-map.cfm, so the stray write corrupted the map's copy
				// of every location id on any location click.
				if(location.locationID == locationChoiceID) {
					toggleLocationForm(location,locationChoiceID);
				}
			}
			doctorSelect();
		});

		$('#' + formPrefix + 'currentURL').val(window.location.href);

		// Prevent duplicate submissions at the form level
		$('#' + formPrefix + 'contactform').on('submit', function(e) {
			if($(this).data('submitting') === true) {
				e.preventDefault();
				e.stopImmediatePropagation();
				return false;
			}
		});

		$.extend($.validator.messages, {
			required: 'Please complete this required field.'
		});

		var contactForm = $('#' + formPrefix + 'contactform').validate({
			focusInvalid: false,
			rules:{
				message:{
					required:false,
					minlength: 1,
					maxlength: 1000
				}
			},
			messages: {
				message: 'Your message is not a valid length'
			},
			highlight: function (input) {
				if ($(input).hasClass('conradio')) {
					$(input).closest('[role="radiogroup"]').addClass('radio-group-error');
					$(input).attr('aria-invalid', 'true');
				} else if ($(input).hasClass('how-heard')) {
					$(input).parents('.form-group').find('span').addClass('error');
					$(input).attr('aria-invalid', 'true');
				} else {
					$(input).addClass('error');
					$(input).attr('aria-invalid', 'true');
				}
			},
			unhighlight: function (input) {
				if ($(input).hasClass('conradio')) {
					$(input).closest('[role="radiogroup"]').removeClass('radio-group-error');
					$(input).removeAttr('aria-invalid');
				} else if ($(input).hasClass('how-heard')) {
					$(input).parents('.form-group').find('span').removeClass('error');
					$(input).removeAttr('aria-invalid');
				} else {
					$(input).removeClass('error');
					$(input).removeAttr('aria-invalid');
				}
			},

			errorPlacement: function(error, element) {
				error.addClass('field-error-msg');
				if (element.hasClass('conradio')) {
					var $group = element.closest('[role="radiogroup"]');
					if (!$group.find('.field-error-msg').length) {
						$group.append(error);
					}
				} else {
					error.insertAfter(element);
				}
			},
			invalidHandler: function(event, validator) {
				var errors = validator.numberOfInvalids();

				if (errors) {
					$('#' + formPrefix + 'contact-form-errors').empty();
					$('#' + formPrefix + 'contact-form-errors').css('display', 'block');
					$('.contact-pod').css('height', 'auto');
					validationFeedbackMessage(errors);

					$('form').on('click', '.fix-it', function() {
						validator.errorList[0].element.focus();
					});

					$('#' + formPrefix + 'contactform input, #' + formPrefix + 'contactform textarea').on('change keyup', function(event) {
						validationFeedbackMessage(validator.checkForm());
					});
					$('input[name=newOrExisting]').on('click',function(e) {
						validationFeedbackMessage(validator.checkForm());
					});
				}
			},
			submitHandler: function (form) {
				// Prevent duplicate submissions - check flags FIRST
				if(isSubmitting || $('#' + formPrefix + 'contactform').data('submitting') === true) {
					return false;
				}

				var formValid = true;
				if (useSpamControl) {
					var fields = $('#' + formPrefix + 'contactform').serializeArray();
					var resp = '';
					for(let field of fields) {
						if(field.name === 'g-recaptcha-response') {
							resp = field.value;
						}
					}
					if(!resp.length) {
						formValid = false;
						$('#' + formPrefix + 'contact-form-errors').empty();
						$('#' + formPrefix + 'contact-form-errors').css('display', 'block');
						$('.contact-pod').css('height', 'auto');
						var message = 'Oops, you missed at least one required field. <br>  Please complete the reCAPTCHA.';
						$('#' + formPrefix + 'contact-form-errors').removeClass('all-fixed');
						$('#' + formPrefix + 'contact-form-errors').empty().append(message);
						return false;
					}
				}
				if(formValid) {
					// Set flags IMMEDIATELY to prevent duplicate submissions
					isSubmitting = true;
					$('#' + formPrefix + 'contactform').data('submitting', true);

					// Disable submit button after validation passes
					$('#' + formPrefix + 'submitter').prop('disabled', true).addClass('disabled');
					if($('#' + formPrefix + 'submitterDisabled').length) {
						$('#' + formPrefix + 'submitter').hide();
						$('#' + formPrefix + 'submitterDisabled').show();
					}

					// Start timeout safeguard before submitting
					startSubmissionTimeout();

					// Submit the form (doSubmitForm handles QA test and native submit)
					doSubmitForm(form);

					return false; // Prevent jQuery validation from submitting again
				}
				return false;
			}
		});

		// For reCAPTCHA sites the g-recaptcha button fires CAPTCHA before jQuery validate runs.
		// The capture-phase listener fires before reCAPTCHA's handler so we can block submission
		// when the form is invalid.
		var submitterEl = document.getElementById(formPrefix + 'submitter');
		if (submitterEl) {
			submitterEl.addEventListener('click', function(e) {
				if (!$('#' + formPrefix + 'contactform').valid()) {
					e.stopImmediatePropagation();
					e.preventDefault();
				}
			}, true);
		}

		function validationFeedbackMessage(errors) {
			var message;
			if (Number.isInteger(errors)) {
				errors = false;
			}
			if (errors) {
				message = "All Fixed :)";
				$('#' + formPrefix + 'contact-form-errors').addClass('all-fixed');
			} else {
				message = 'Oops, you missed at least one required field. <br>  Please review the highlighted fields below.';
				$('#' + formPrefix + 'contact-form-errors').removeClass('all-fixed');
			}

			$('#' + formPrefix + 'contact-form-errors').empty().append(message);
		}

	});
}

/**
 * One config island per rendered form.
 *
 * This runs at parse time rather than on ready, to keep the original ordering:
 * the inline block published its reCAPTCHA/podium globals and called
 * doctorSelect() immediately, and only deferred the DOM wiring to
 * $(document).ready. gpw-public.min.js is loaded from externalScripts.cfm at
 * fullTemplate.cfm:396, just before </body> and after both publicModals.cfm and
 * the page body, so every island is already in the DOM by the time we scan.
 */
(function() {
	var shared = window.gpwContactForm;
	if (!shared) return;

	$('script.gpw-contact-form-config').each(function() {
		var config;
		try {
			config = JSON.parse(this.textContent);
		} catch (e) {
			return;
		}
		initContactForm(config, shared);
	});
})();



// WEBPACK FOOTER //
// ./gpw-contact-form.js